<template>
  <CancelHireModal :open="open" :hire-id="hireId" @close="$emit('update:open', false)" />
</template>

<script lang="ts" setup>
import CancelHireModal from '@/components/Hire/CancelHireModal.vue'

defineProps<{
  open: boolean
  hireId: string
}>()

defineEmits<{
  'update:open': [value: boolean]
}>()
</script>
